import { gameRoutes, type GameMeta, type SimpleDate } from '@puzzlio/core';
import { colors } from '@puzzlio/tokens';

/** This game's cross-platform metadata; see GameMeta. */
export const meta: GameMeta = {
  type: 'mosaic',
  gameId: 5,
  label: 'Mosaic',
  description: 'Follow the clues to reveal a hidden picture',
  emoji: '🖼️',
  buttonColor: 'purple',
  // The dot is a blend rather than a palette entry, which is why it stays a literal.
  background: { fill: colors['purple-100'], dot: '#e3d4fe' },
  burst: { inner: colors['purple-300'], outer: colors['purple-200'] },
  separator: colors['purple-600'],
  earliestDate: '2026-08-24' as SimpleDate,
  tutorialSlug: 'tutorial-1',
  practiceCollections: [
    { level: 1, puzzles: ['easy-1', 'easy-2', 'easy-3'] },
    { level: 2, puzzles: ['medium-1', 'medium-2', 'medium-3'] },
    { level: 3, puzzles: ['hard-1', 'hard-2', 'hard-3'] },
  ],
  enableHints: true,
  availability: 'accountHolders',
  ...gameRoutes('/games/mosaic'),
};
